/**
 * An insurance card's fields as a reader sees them: the one list the
 * Insurance card and the face sheet both show, in the form's order, each
 * with the label its box carries. Only the fields that hold a value are
 * listed. Codes (member ID, group number, Rx BIN / PCN / group) read
 * exactly as stored; the phone on the card reads formatted; the card
 * holder reads with the relationship to the client in brackets.
 */

import type { CoverageRow } from '@/lib/clientRecord';
import { formatPhoneDisplay } from '@/lib/phone';
import { recordFieldLabel } from '@/lib/recordFormWords';

export interface CoverageCardFact {
  label: string;
  value: string;
}

function holder(row: CoverageRow): string | undefined {
  const name = row.holderName?.trim() ?? '';
  const relationship = row.holderRelationship?.trim() ?? '';
  if (name === '' && relationship === '') return undefined;
  if (name === '') return relationship;
  return relationship === '' ? name : `${name} (${relationship})`;
}

export function coverageCardFacts(row: CoverageRow): CoverageCardFact[] {
  const phone = row.cardPhone === undefined ? undefined : formatPhoneDisplay(row.cardPhone);
  const facts: Array<[string, string | undefined]> = [
    ['plan_name', row.planName],
    ['member_id', row.memberId],
    ['group_number', row.groupNumber],
    ['card_phone', phone],
    ['rx_bin', row.rxBin],
    ['rx_pcn', row.rxPcn],
    ['rx_group', row.rxGroup],
    ['holder_name', holder(row)],
  ];
  return facts
    .filter((f): f is [string, string] => f[1] !== undefined && f[1].trim() !== '')
    .map(([field, value]) => ({ label: recordFieldLabel('coverage', field), value }));
}
